import React, { useEffect, useState, useContext } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { UserOrderContext } from '../../../context/context';
import { Footer } from 'organisms/FooterComponent';
import { getContentCall } from '@kfc-global/react-shared/redux/Actions/ContentAction';
import getMarketConfigContentCall from '@kfc-global/react-shared/redux/Actions/MarketConfigAction';
import OrderConfirmScreen from 'organisms/PaymentProcess/Presentation/orderConfirmStatus';
import OrderReceivedScreen from 'organisms/PaymentProcess/Presentation/orderReceivedScreen';
import OrderReceivedDeliveryCard from 'organisms/PaymentProcess/Presentation/orderReceivedDeliveryCard';
import { SecondaryHeader } from 'organisms/HeaderComponent';
import { getBulkStoreStatus } from '@kfc-global/react-shared/redux/Actions/StoresAction';
import {
  isEmptyEvery,
  getFooterData,
  getHeaderData,
  isEmptyObject,
  getValueOrnull,
  getValueOrDefaultObject,
  redirectToGiftCardPage,
} from '../../../common/utilities/utils';
import { updatePurchaseAnalytics } from '../../../organisms/PaymentProcess/PaymentProcessUtils';
import { getCmsClient } from 'common/utilities/cmsClient';

import {
  isOrderPOSCompleted,
  checkInvalidateCart,
  postOrderApiCall,
  orderAcceptedUpdate,
  isDeliveryDistOrder,
  isDeliveryDistaOrderPolling,
  isDeliveryDistaOrderPOSCompleted,
  isDeliveryDistaOrderPartner,
  onDeliveryDistaValidateAndRedirection,
  updateOrderDetails,
  updateDefaultOrderDetails,
  isStagedAcceptedOrder,
  getPostOrderDetails,
  resetOrderReducers,
  dispatchGetPastOrderDetails,
} from './paymentProcessingFn';
import { ChannelManager } from 'common/manager';
import { LOCAL_STORAGE_KEYS, PAYMENT_STATUS } from '../../../common/constants/SharedConstants';
import SaveOrderComponent from 'organisms/PaymentProcess/Presentation/SaveOrderComponent';
import { MAX_RETRY_DELIVERY_INTERVAL } from './constants';
import { PAYMENT_TENDER_TYPES } from 'common/constants/SharedConstants';

export const PaymentProcess = props => {
  let segmentedMarketingData = null,
    segmentedFooterData = null;
  const { userOrderState } = useContext(UserOrderContext);
  const { tenantReducer, appStateReducer, orderReducer, postOrderReducer, cartReducer, storesReducer } = useSelector(
    data => data,
  );
  const txnID = useSelector(data => data?.postOrderReducer?.cashTranscationResponse?.transactionId);
  const flatResponse = useSelector(({ menuReducer: { flatResponse } }) => flatResponse);
  const dispatch = useDispatch();
  const { userStatus } = appStateReducer;
  const { cartData, isBasketLoading, qrCodeScanTime } = cartReducer;

  const dispositionPaymentPage = isEmptyEvery(userOrderState.dispositionNew)
    ? JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.DISPOSITION_NEW))
    : userOrderState.dispositionNew;

  const [orderDetails, setOrderDetails] = useState(
    updateDefaultOrderDetails(
      tenantReducer?.tenantId,
      getPostOrderDetails(postOrderReducer, orderReducer, {}, false),
      orderReducer?.response?.order,
      dispositionPaymentPage,
    ),
  );

  const [stagedPage, setStagedPage] = useState(true);
  const [retryCount, setRetryCount] = useState(0);
  const [displayDeliveryDistaPage, setDisplayDeliveryDistaPage] = useState(false);
  const [checkDeliveryPOSCompleted, setCheckDeliveryPOSCompleted] = useState(false);
  const [isAnalyticsUpdated, setIsAnalyticsUpdated] = useState(false);

  // defines user's current state
  const userParamsFromStore = useSelector(data => {
    return data.appStateReducer.userStatus;
  });

  const getOperatingTime = orderDet => {
    const payload = [
      {
        storeId: orderDet?.store?.storeId,
        channel: ChannelManager.channel,
        service: orderDet?.service,
      },
    ];
    const isFavoritePage = false;
    const tenantId = tenantReducer?.tenantId;
    dispatch(getBulkStoreStatus({ data: payload, tenantId, isFavoritePage }));
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  });

  useEffect(() => {
    window.removeEventListener('beforeunload', () => resetOrderReducers(dispatch, true), true);
    window.addEventListener('beforeunload', () => resetOrderReducers(dispatch, true));
    return () => {
      window.removeEventListener('beforeunload', () => resetOrderReducers(dispatch), true);
      setOrderDetails({});
      resetOrderReducers(dispatch);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const postOrderDetails = getPostOrderDetails(postOrderReducer, orderReducer, {}, false);
    if (postOrderDetails && Object.keys(postOrderDetails).length) {
      if (!isStagedAcceptedOrder(postOrderDetails) && !isAnalyticsUpdated) {
        getOperatingTime(postOrderDetails);
        const { currencyConversionFactor } = tenantReducer;
        orderReducer?.response?.order?.tenders[0]?.type !== PAYMENT_TENDER_TYPES.PAY_BY_CASH &&
          updatePurchaseAnalytics(postOrderDetails, currencyConversionFactor, userStatus, flatResponse); //OrderReducerData
        setIsAnalyticsUpdated(true);
      }
      onDeliveryDistaValidateAndRedirection(postOrderDetails, checkDeliveryPOSCompleted, setCheckDeliveryPOSCompleted);

      updateOrderDetails(postOrderDetails, orderDetails, setOrderDetails, checkDeliveryPOSCompleted, props);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [postOrderReducer?.orderAccepted, orderReducer?.pastOrderResponse]);

  useEffect(() => {
    const cashTransactionID = txnID;
    const postOrderDetails = getPostOrderDetails(postOrderReducer, orderReducer, {}, false);
    const { currencyConversionFactor } = tenantReducer;
    if (postOrderDetails && Object.keys(postOrderDetails).length) {
      onDeliveryDistaValidateAndRedirection(postOrderDetails, checkDeliveryPOSCompleted, setCheckDeliveryPOSCompleted);
      updateOrderDetails(postOrderDetails, orderDetails, setOrderDetails, checkDeliveryPOSCompleted, props);
      orderReducer?.response?.order?.tenders[0]?.type === PAYMENT_TENDER_TYPES.PAY_BY_CASH &&
        updatePurchaseAnalytics(
          postOrderDetails,
          currencyConversionFactor,
          userStatus,
          flatResponse,
          cashTransactionID,
        );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [txnID]);

  const callPostOrderAPI = () => {
    const postOrderDetails = getPostOrderDetails(postOrderReducer, orderReducer, {}, false);
    postOrderApiCall(dispatch, orderDetails, retryCount, postOrderDetails, setRetryCount, props);
  };

  useEffect(() => {
    stagedPage && retryCount > 0 && callPostOrderAPI();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [retryCount]);

  useEffect(() => {
    if (tenantReducer?.tenantId) {
      if (sessionStorage.getItem(LOCAL_STORAGE_KEYS.ORDER_TRACKING)) {
        let tempObj = JSON.parse(sessionStorage.getItem(LOCAL_STORAGE_KEYS.ORDER_TRACKING));
        if (tempObj && Object.keys(tempObj).length) {
          if (tempObj?.postOrderDetails && Object.keys(tempObj?.postOrderDetails).length === 0) {
            dispatchGetPastOrderDetails(dispatch, tempObj);
          }
          setOrderDetails({
            ...orderDetails,
            ...tempObj,
            deliveryDistaRetryCountFlag: tempObj?.postOrderDetails ? 1 : 0,
            operatingTime: storesReducer?.storesWithStatus?.[0]?.summary?.timings,
          });
        } else {
          orderDetails && callPostOrderAPI();
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tenantReducer?.tenantId]);

  useEffect(() => {
    dispatch(
      getMarketConfigContentCall({
        object: getCmsClient(),
        contentFull: {
          content_type: 'marketConfig',
          'fields.location': allReducerData?.tenantReducerContent?.country,
          'fields.channel': ChannelManager.channel,
          include: 5,
        },
      }),
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  useEffect(() => {
    dispatch(
      getContentCall({
        object: getCmsClient(),
        contentFull: {
          content_type: 'landingPage',
          'fields.pageType': 'HomePage',
          'fields.channel': ChannelManager.channel,
          include: '5',
        },
        userStatus,
      }),
    );
  }, [dispatch, userStatus, tenantReducer?.tenantId]);

  useEffect(() => {
    let dispatchGetPostOrderTimer = null;
    if (stagedPage && !isDeliveryDistaOrderPartner(orderDetails)) {
      const updateOrderAccepted = async () => {
        const postOrderDetails = getPostOrderDetails(postOrderReducer, orderReducer, {}, false);
        const status = await orderAcceptedUpdate(postOrderDetails, setStagedPage, props);
        // check for invalidate cart for member user
        checkInvalidateCart(
          dispatch,
          orderDetails,
          postOrderDetails,
          cartData,
          userOrderState,
          appStateReducer,
          isBasketLoading,
          status,
          qrCodeScanTime,
        );
      };
      updateOrderAccepted();
    }

    if (isDeliveryDistOrder(orderDetails) && !displayDeliveryDistaPage) {
      setDisplayDeliveryDistaPage(true);
      setStagedPage(false);
    }

    if (orderDetails?.orderId && isDeliveryDistaOrderPolling(orderDetails)) {
      dispatchGetPostOrderTimer = setTimeout(() => {
        dispatchGetPastOrderDetails(dispatch, orderDetails);
      }, MAX_RETRY_DELIVERY_INTERVAL);
    }

    return () => {
      dispatchGetPostOrderTimer && clearTimeout(dispatchGetPostOrderTimer);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orderDetails?.deliveryDistaRetryCountFlag]);

  useEffect(() => {
    if (localStorage.getItem(LOCAL_STORAGE_KEYS.POST_PAYMENT_TYPE) === 'giftCardPurchase') {
      localStorage.setItem(LOCAL_STORAGE_KEYS.PAYMENT_STATUS, PAYMENT_STATUS.SUCCESS);
      redirectToGiftCardPage(props);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const allReducerData = useSelector(data => {
    return {
      homePageContent: getValueOrnull(data.contentReducer.response),
      marketPageContent: getValueOrnull(data.marketConfigReducer.response),
      tenantReducerContent: getValueOrnull(data.tenantReducer),
    };
  });

  if (allReducerData.marketPageContent && allReducerData.tenantReducerContent && allReducerData.homePageContent) {
    const { header = {}, footer = {} } = getValueOrDefaultObject(allReducerData.marketPageContent.headerData);
    segmentedMarketingData = getHeaderData(header);
    segmentedFooterData = getFooterData(footer);
  }

  return (
    <React.Fragment>
      <div className='PostPaymentProcessComponent'>
        {isEmptyObject(segmentedMarketingData) && (
          <SecondaryHeader
            contentData={segmentedMarketingData}
            tenantReducerData={allReducerData.tenantReducerContent}
            userParams={userParamsFromStore}
            paymentHeader={true}
            checkoutHeader={false}
          />
        )}

        {stagedPage && <OrderConfirmScreen retryCount={retryCount} />}

        {/* except Delivery */}
        {isOrderPOSCompleted(orderDetails) && !isDeliveryDistaOrderPOSCompleted(orderDetails) && (
          <OrderReceivedScreen
            orderReducerData={getPostOrderDetails(postOrderReducer, orderReducer, orderDetails)}
            userParams={userParamsFromStore}
            tenantReducer={tenantReducer}
            orderDetails={orderDetails}
          />
        )}

        {/* Delivery  */}
        {displayDeliveryDistaPage && (
          <div>
            <OrderReceivedDeliveryCard
              orderDetails={orderDetails}
              orderReducerData={getPostOrderDetails(postOrderReducer, orderReducer, orderDetails)}
              tenantReducer={tenantReducer}
            />
            <SaveOrderComponent
              orderReducerData={getPostOrderDetails(postOrderReducer, orderReducer, orderDetails)}
              userParams={userParamsFromStore}
              tenantReducer={tenantReducer}
              orderDetails={orderDetails}
            />
          </div>
        )}

        {isEmptyObject(segmentedFooterData) && (
          <Footer
            contentData={segmentedFooterData}
            history={props.history}
            tenantReducerData={allReducerData.tenantReducerContent}
          />
        )}
      </div>
    </React.Fragment>
  );
};
